import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {VehicleBase} from '@app/vehicle/shared/vehicle-base';
import {Bag} from '../objects/bag';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class InfoApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/info`;
  }

  public vehicle(vrn: string): Observable<VehicleBase> {
    return this.httpClient.get<VehicleBase>(`${this.endpoint}/vehicles/${vrn}`);
  }

  public bag(zip: string, houseNumber: string): Observable<Bag[]> {
    return this.httpClient.get<Bag[]>(`${this.endpoint}/bag/${zip}/${houseNumber}`);
  }

  public vies(iso: string, vatNumber: string): Observable<unknown> {
    return this.httpClient.get<Bag[]>(`${this.endpoint}/vies/${iso}/${vatNumber}`);
  }

}
